(function () {
  'use strict';

  const COOKIE_NAME = 'tarte_locale_suggestion_dismissed';
  const DISMISSAL_MAX_AGE_SECONDS = 60 * 60 * 24 * 365;
  const DETECTED_COUNTRY_STORAGE_KEY = 'tarte_locale_detected_country';
  const TOKEN_COUNTRY = '[country]';
  const TOKEN_CURRENCY = '[currency]';

  const banner = document.getElementById('locale-suggestion-banner');
  const modal = document.getElementById('locale-suggestion-country-modal');
  if (!banner || !modal) return;

  const localeRouting = window.TarteLocaleRouting || null;
  const currentCountry = String(banner.dataset.currentCountry || '').toUpperCase();
  const shopifyLanguage = banner.dataset.currentLanguage || '';
  const currentLanguage = localeRouting
    ? localeRouting.getActiveLanguage(currentCountry, shopifyLanguage)
    : shopifyLanguage;
  const closeButton = banner.querySelector('[data-locale-suggestion-close]');
  const chooseCountryButton = banner.querySelector('[data-locale-suggestion-choose-country]');
  const shopButton = banner.querySelector('[data-locale-suggestion-shop]');
  const continueButton = banner.querySelector('[data-locale-suggestion-continue]');
  const liveRegion = document.querySelector('[data-locale-suggestion-live-region]');

  const modalCloseButton = modal.querySelector('[data-locale-country-modal-close]');
  const countryCombobox = modal.querySelector('.locale-suggestion-country-modal__combobox');
  const countryInput = modal.querySelector('#locale-suggestion-country-input');
  const countryToggle = modal.querySelector('[data-locale-country-toggle]');
  const countryList = modal.querySelector('#locale-suggestion-country-list');
  const currencyBadge = modal.querySelector('[data-locale-country-currency]');
  const modalLanguageSection = modal.querySelector('[data-locale-country-languages]');
  const modalLanguageList = modal.querySelector('[data-locale-country-language-list]');
  const modalContinueButton = modal.querySelector('[data-locale-country-continue]');
  const form = modal.querySelector('#locale-suggestion-localization-form');
  const formCountry = modal.querySelector('[data-locale-suggestion-form-country]');
  const formLanguage = modal.querySelector('[data-locale-suggestion-form-language]');
  const formReturn = modal.querySelector('[data-locale-suggestion-form-return]');

  let marketLanguageMap = {};
  let detectedCountry = null;
  let bannerLanguage = null;
  let modalCountry = null;
  let modalLanguage = null;
  let countryListOpen = false;
  let focusedCountryOption = null;
  let modalOpener = null;
  let inertedElements = [];

  function init() {
    marketLanguageMap = localeRouting ? localeRouting.marketLanguageMap : readMarketLanguageMap();
    if (!currentCountry || hasDismissalCookie() || !Object.keys(marketLanguageMap).length) return;

    bindEvents();
    detectCountry();
  }

  function readMarketLanguageMap() {
    const mapElement = document.getElementById('market-language-map');
    if (!mapElement) return {};

    try {
      return JSON.parse(mapElement.textContent || '{}');
    } catch (error) {
      console.error('locale-suggestion: unable to read the market language map', error);
      return {};
    }
  }

  async function detectCountry() {
    const cachedCountry = getCachedDetectedCountry();
    if (cachedCountry) {
      if (cachedCountry !== currentCountry && marketLanguageMap[cachedCountry]) {
        showBanner(cachedCountry);
      }
      return;
    }

    const root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root
      : '/';
    const query = new URLSearchParams({
      'country[enabled]': 'true',
      'country[exclude]': currentCountry
    });

    try {
      const response = await fetch(root + 'browsing_context_suggestions.json?' + query.toString(), {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' }
      });
      if (!response.ok) return;

      const data = await response.json();
      const countryCode = String(data && data.detected_values && data.detected_values.country
        ? data.detected_values.country.handle
        : '').toUpperCase();

      if (!countryCode) return;
      cacheDetectedCountry(countryCode);
      if (countryCode === currentCountry || !marketLanguageMap[countryCode]) return;
      showBanner(countryCode);
    } catch (error) {
      console.warn('locale-suggestion: country detection failed', error);
    }
  }

  function bindEvents() {
    closeButton.addEventListener('click', dismissBanner);
    continueButton.addEventListener('click', dismissBanner);
    shopButton.addEventListener('click', function () {
      submitLocalization(detectedCountry, bannerLanguage);
    });
    chooseCountryButton.addEventListener('click', openCountryModal);

    modalCloseButton.addEventListener('click', closeCountryModal);
    modal.addEventListener('mousedown', function (event) {
      if (event.target === modal) closeCountryModal();
    });
    modal.addEventListener('keydown', onModalKeydown);

    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', syncCountryModalViewport);
      window.visualViewport.addEventListener('scroll', syncCountryModalViewport);
    }

    watchStickyAddToBag();

    countryInput.addEventListener('input', filterCountryOptions);
    countryInput.addEventListener('blur', onCountryComboboxBlur);
    countryInput.addEventListener('keydown', onCountryInputKeydown);
    countryInput.addEventListener('click', function () {
      if (!countryListOpen) {
        countryInput.value = '';
        openCountryList();
      }
    });
    countryToggle.addEventListener('click', function () {
      if (countryListOpen) {
        closeCountryList();
      } else {
        countryInput.value = '';
        openCountryList();
        countryInput.focus();
      }
    });
    countryToggle.addEventListener('blur', onCountryComboboxBlur);
    document.addEventListener('mousedown', onCountryComboboxOutsideClick);

    countryList.querySelectorAll('[role="option"]').forEach(function (option) {
      option.addEventListener('mousedown', function (event) { event.preventDefault(); });
      option.addEventListener('click', function () { selectModalCountry(option.dataset.countryCode); });
    });

    modalContinueButton.addEventListener('click', function () {
      submitLocalization(modalCountry, modalLanguage);
    });
  }

  function onCountryComboboxBlur() {
    window.setTimeout(function () {
      if (countryListOpen && !countryCombobox.contains(document.activeElement)) {
        closeCountryList();
      }
    }, 150);
  }

  function onCountryComboboxOutsideClick(event) {
    if (countryListOpen && !countryCombobox.contains(event.target)) {
      closeCountryList();
    }
  }

  function watchStickyAddToBag() {
    const stickyBar = document.querySelector('.sticky-bar-atb');
    if (!stickyBar) return;

    function syncStickyOffset() {
      const isVisible = stickyBar.classList.contains('nav-down')
        && window.getComputedStyle(stickyBar).display !== 'none';
      const offset = isVisible ? Math.ceil(stickyBar.getBoundingClientRect().height) : 0;
      banner.style.setProperty('--locale-suggestion-sticky-offset', offset + 'px');
    }

    const classObserver = new MutationObserver(syncStickyOffset);
    classObserver.observe(stickyBar, { attributes: true, attributeFilter: ['class'] });

    if (window.ResizeObserver) {
      const sizeObserver = new ResizeObserver(syncStickyOffset);
      sizeObserver.observe(stickyBar);
    } else {
      window.addEventListener('resize', syncStickyOffset);
    }

    syncStickyOffset();
  }

  function showBanner(countryCode) {
    const country = marketLanguageMap[countryCode];
    const preferredLanguage = getPreferredLanguage(countryCode, currentLanguage);
    detectedCountry = countryCode;
    banner.querySelector('[data-locale-suggestion-intro]').textContent = interpolate(
      banner.dataset.messageIntro,
      country.name,
      country.currency
    );
    banner.querySelector('[data-locale-suggestion-detail]').textContent = interpolate(
      banner.dataset.messageDetail,
      country.name,
      country.currency
    );
    chooseCountryButton.textContent = interpolate(
      banner.dataset.chooseCountryLabel,
      country.name,
      country.currency
    );
    shopButton.textContent = interpolate(
      banner.dataset.shopLabel,
      country.name,
      country.currency
    );

    const current = marketLanguageMap[currentCountry];
    continueButton.textContent = interpolate(
      banner.dataset.continueLabel,
      current ? current.name : currentCountry,
      current ? current.currency : ''
    );

    bannerLanguage = preferredLanguage;
    banner.hidden = false;
    document.body.classList.add('locale-suggestion-banner-open');

    if (liveRegion) {
      window.requestAnimationFrame(function () {
        liveRegion.textContent = interpolate(banner.dataset.announcement, country.name, country.currency);
      });
    }
  }

  function dismissBanner() {
    setDismissalCookie();
    banner.hidden = true;
    document.body.classList.remove('locale-suggestion-banner-open');
    if (liveRegion) liveRegion.textContent = '';
  }

  function openCountryModal() {
    if (!detectedCountry) return;

    modalOpener = chooseCountryButton;
    selectModalCountry(detectedCountry, bannerLanguage || currentLanguage);
    modal.hidden = false;
    syncCountryModalViewport();
    document.body.classList.add('locale-suggestion-modal-open');
    inertBackground();
    modalCloseButton.focus();
  }

  function syncCountryModalViewport() {
    if (window.innerWidth > 749 || !window.visualViewport) {
      modal.style.removeProperty('top');
      modal.style.removeProperty('bottom');
      modal.style.removeProperty('height');
      return;
    }

    modal.style.top = window.visualViewport.offsetTop + 'px';
    modal.style.bottom = 'auto';
    modal.style.height = window.visualViewport.height + 'px';
  }

  function closeCountryModal() {
    if (modal.hidden) return;

    closeCountryList();
    modal.hidden = true;
    document.body.classList.remove('locale-suggestion-modal-open');
    restoreBackground();

    if (modalOpener && document.contains(modalOpener)) modalOpener.focus();
  }

  function inertBackground() {
    inertedElements = [];
    Array.from(document.body.children).forEach(function (element) {
      if (element !== modal && !element.hasAttribute('inert')) {
        element.setAttribute('inert', '');
        inertedElements.push(element);
      }
    });
  }

  function restoreBackground() {
    inertedElements.forEach(function (element) { element.removeAttribute('inert'); });
    inertedElements = [];
  }

  function onModalKeydown(event) {
    if (event.key === 'Escape') {
      event.preventDefault();
      closeCountryModal();
      return;
    }

    if (event.key !== 'Tab') return;
    const focusable = getFocusableElements(modal);
    if (!focusable.length) return;

    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  function getFocusableElements(container) {
    return Array.from(container.querySelectorAll(
      'button:not([disabled]), input:not([disabled]), [href], [tabindex]:not([tabindex="-1"])'
    )).filter(function (element) {
      return !element.hidden && element.offsetParent !== null;
    });
  }

  function selectModalCountry(countryCode, preferredLanguage) {
    const normalizedCode = String(countryCode || '').toUpperCase();
    const country = marketLanguageMap[normalizedCode];
    const option = countryList.querySelector('[data-country-code="' + normalizedCode + '"]');
    if (!country || !option) return;

    modalCountry = normalizedCode;
    countryList.querySelectorAll('[role="option"]').forEach(function (item) {
      const selected = item === option;
      item.classList.toggle('is-selected', selected);
      item.setAttribute('aria-selected', String(selected));
    });

    countryInput.value = option.dataset.countryName;
    currencyBadge.textContent = option.dataset.countryCurrency;
    currencyBadge.hidden = !option.dataset.countryCurrency;
    closeCountryList();

    modalLanguage = renderLanguages(
      modalLanguageList,
      normalizedCode,
      preferredLanguage || modalLanguage || currentLanguage,
      function (languageCode) { modalLanguage = languageCode; }
    );
    modalLanguageSection.hidden = !modalLanguage;
    modalContinueButton.textContent = interpolate(
      banner.dataset.selectorContinueLabel,
      country.name,
      country.currency
    );
    modalContinueButton.disabled = !(modalCountry && modalLanguage);
  }

  function renderLanguages(container, countryCode, preferredLanguage, onSelect) {
    const country = marketLanguageMap[countryCode];
    const languages = localeRouting
      ? localeRouting.getLanguages(countryCode)
      : (country && Array.isArray(country.languages) ? country.languages : []);
    container.innerHTML = '';
    if (!languages.length) return null;

    let selectedCode = localeRouting
      ? localeRouting.getPreferredLanguage(countryCode, preferredLanguage)
      : null;
    if (!selectedCode) {
      const preferred = languages.find(function (language) {
        return language.iso_code === preferredLanguage;
      });
      selectedCode = preferred ? preferred.iso_code : languages[0].iso_code;
    }

    languages.forEach(function (language) {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'locale-suggestion__language-button';
      button.textContent = language.display_name || formatLanguageName(language.name, language.iso_code);
      button.dataset.languageCode = language.iso_code;
      button.setAttribute('aria-pressed', String(language.iso_code === selectedCode));
      button.classList.toggle('is-selected', language.iso_code === selectedCode);
      button.addEventListener('click', function () {
        selectedCode = language.iso_code;
        container.querySelectorAll('button').forEach(function (languageButton) {
          const isSelected = languageButton === button;
          languageButton.classList.toggle('is-selected', isSelected);
          languageButton.setAttribute('aria-pressed', String(isSelected));
        });
        onSelect(selectedCode);
      });
      container.appendChild(button);
    });

    return selectedCode;
  }

  function getPreferredLanguage(countryCode, preferredLanguage) {
    if (localeRouting) return localeRouting.getPreferredLanguage(countryCode, preferredLanguage);

    const country = marketLanguageMap[countryCode];
    const languages = country && Array.isArray(country.languages) ? country.languages : [];
    if (!languages.length) return null;

    const preferred = languages.find(function (language) {
      return language.iso_code === preferredLanguage;
    });
    return preferred ? preferred.iso_code : languages[0].iso_code;
  }

  function openCountryList() {
    if (countryListOpen) return;
    countryListOpen = true;
    countryList.hidden = false;
    countryInput.setAttribute('aria-expanded', 'true');
    countryToggle.setAttribute('aria-expanded', 'true');
    countryToggle.classList.add('is-open');
    currencyBadge.hidden = true;
    filterCountryOptions();
  }

  function closeCountryList() {
    if (!countryListOpen) return;
    countryListOpen = false;
    countryList.hidden = true;
    countryInput.setAttribute('aria-expanded', 'false');
    countryInput.removeAttribute('aria-activedescendant');
    countryToggle.setAttribute('aria-expanded', 'false');
    countryToggle.classList.remove('is-open');
    setFocusedCountryOption(null);

    if (modalCountry) {
      const selected = countryList.querySelector('[data-country-code="' + modalCountry + '"]');
      if (selected) {
        countryInput.value = selected.dataset.countryName;
        currencyBadge.textContent = selected.dataset.countryCurrency;
        currencyBadge.hidden = !selected.dataset.countryCurrency;
      }
    }
  }

  function filterCountryOptions() {
    if (!countryListOpen) openCountryList();
    const query = normalize(countryInput.value);
    let firstVisible = null;

    countryList.querySelectorAll('[role="option"]').forEach(function (option) {
      const isVisible = !query || normalize(option.dataset.countryName).includes(query);
      option.hidden = !isVisible;
      if (isVisible && !firstVisible) firstVisible = option;
    });

    setFocusedCountryOption(firstVisible);
  }

  function onCountryInputKeydown(event) {
    if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
      event.preventDefault();
      if (!countryListOpen) openCountryList();
      moveFocusedCountryOption(event.key === 'ArrowDown' ? 1 : -1);
    } else if (event.key === 'Enter' && countryListOpen && focusedCountryOption) {
      event.preventDefault();
      selectModalCountry(focusedCountryOption.dataset.countryCode);
    }
  }

  function moveFocusedCountryOption(direction) {
    const options = Array.from(countryList.querySelectorAll('[role="option"]')).filter(function (option) {
      return !option.hidden;
    });
    if (!options.length) return;

    const currentIndex = focusedCountryOption ? options.indexOf(focusedCountryOption) : -1;
    const nextIndex = currentIndex < 0
      ? (direction > 0 ? 0 : options.length - 1)
      : (currentIndex + direction + options.length) % options.length;
    setFocusedCountryOption(options[nextIndex]);
  }

  function setFocusedCountryOption(option) {
    if (focusedCountryOption) focusedCountryOption.classList.remove('is-focused');
    focusedCountryOption = option;

    if (!option) {
      countryInput.removeAttribute('aria-activedescendant');
      return;
    }

    option.classList.add('is-focused');
    option.scrollIntoView({ block: 'nearest' });
    countryInput.setAttribute('aria-activedescendant', option.id);
  }

  async function submitLocalization(countryCode, languageCode) {
    if (!countryCode || !languageCode || !form) return;

    setDismissalCookie();
    shopButton.disabled = true;
    modalContinueButton.disabled = true;

    const target = localeRouting
      ? localeRouting.getLocalizationTarget(countryCode, languageCode, window.location, currentCountry)
      : {
          navigationMode: 'form',
          localeCode: languageCode,
          returnTo: window.location.pathname + window.location.search + window.location.hash
        };

    if (formCountry) formCountry.value = countryCode;
    if (formLanguage) formLanguage.value = target.localeCode;
    if (formReturn) formReturn.value = target.returnTo;
    if (target.postLocalizationRedirect && localeRouting) {
      localeRouting.queuePostLocalizationRedirect(countryCode, target.postLocalizationRedirect);
    }

    if (typeof window.prepareCartForLocaleSwitch === 'function') {
      try {
        await window.prepareCartForLocaleSwitch({ dataset: { value: countryCode } });
      } catch (error) {
        console.error('locale-suggestion: unable to prepare the cart for a locale switch', error);
      }
    }

    if (target.navigationMode === 'direct') {
      if (localeRouting && localeRouting.isSameDocumentTarget(target.returnTo, window.location)) {
        const currentUrl = window.location.pathname + window.location.search + window.location.hash;
        if (currentUrl !== target.returnTo) window.location.assign(target.returnTo);
        shopButton.disabled = false;
        modalContinueButton.disabled = false;
        closeCountryModal();
        dismissBanner();
        return;
      }
      window.location.assign(target.returnTo);
      return;
    }

    form.submit();
  }

  function hasDismissalCookie() {
    return document.cookie.split('; ').some(function (cookie) {
      return cookie.indexOf(COOKIE_NAME + '=') === 0;
    });
  }

  function getCachedDetectedCountry() {
    try {
      return String(window.sessionStorage.getItem(DETECTED_COUNTRY_STORAGE_KEY) || '').toUpperCase();
    } catch (error) {
      return '';
    }
  }

  function cacheDetectedCountry(countryCode) {
    try {
      window.sessionStorage.setItem(DETECTED_COUNTRY_STORAGE_KEY, countryCode);
    } catch (error) {
      // Detection still works when session storage is unavailable.
    }
  }

  function setDismissalCookie() {
    document.cookie = COOKIE_NAME + '=1; path=/; max-age=' + DISMISSAL_MAX_AGE_SECONDS + '; SameSite=Lax; Secure';
  }

  function interpolate(template, country, currency) {
    const interpolated = String(template || '')
      .split(TOKEN_COUNTRY).join(country || '')
      .split(TOKEN_CURRENCY).join(currency || '');
    const decoder = document.createElement('textarea');
    decoder.innerHTML = interpolated;
    return decoder.value;
  }

  function formatLanguageName(name, languageCode) {
    const stripped = String(name || '').replace(/\s*\([^)]*\)\s*$/, '').trim();
    if (!stripped) return stripped;
    return stripped.charAt(0).toLocaleUpperCase(languageCode) + stripped.slice(1);
  }

  function normalize(value) {
    return String(value || '')
      .normalize('NFD')
      .replace(/\p{Diacritic}/gu, '')
      .toLowerCase();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
